// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Y1C1","title":"BackImages_title__2fl5g","images":"BackImages_images__3M_Yg"};